import { render, staticRenderFns } from "./ContactsIcon.vue?vue&type=template&id=89f36ef6"
import script from "./ContactsIcon.vue?vue&type=script&lang=js"
export * from "./ContactsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports